import { render, staticRenderFns } from "./AddBanner.vue?vue&type=template&id=66c84073&scoped=true"
import script from "./AddBanner.vue?vue&type=script&lang=js"
export * from "./AddBanner.vue?vue&type=script&lang=js"
import style0 from "./AddBanner.vue?vue&type=style&index=0&id=66c84073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c84073",
  null
  
)

export default component.exports